module.exports = __webpack_public_path__ + "img/source_sw-item3.3f81c2c9.png";